import React, { useEffect, useState } from 'react';
import { Typography } from "@mui/material";
import MeetingCard from 'app/components/Card/MeetingCard';
import { setCurrentMeeting, setPageType } from 'stores/meeting';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

const AddMeetingPage = () => {

  const [value, setValue] = useState(0);
  const [tabsLength, setTabsLength] = useState(3);
  const dispatch = useDispatch();
  const [title, setTitle] = useState('');
  const params = useParams();
  const param = params.pageType;

  useEffect(() => {

    setTitle(param === '1' ? " " : "Kurul/Komisyon ");
    dispatch(setPageType(param))
    dispatch(setCurrentMeeting({}))
  }, [param])

  return (
    <React.Fragment>


      <Typography variant="h4" mb={3}>{title}Toplantı Ekleme</Typography>

      <MeetingCard
        type={"card"}
        value={value}
        setValue={setValue}
        setTabsLength={setTabsLength}
      />
    </React.Fragment>
  );
};

export default AddMeetingPage;
